import React from "react";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export const Pager = ({ page, pages, total, onChange, testPrefix = "pager" }) => {
  if (total === 0) return null;
  return (
    <div className="flex flex-wrap items-center justify-between gap-3" data-testid={`${testPrefix}`}>
      <p className="text-xs text-slate-500" data-testid={`${testPrefix}-info`}>
        {total} bon{total > 1 ? "s" : ""} — page {page} / {pages}
      </p>
      <div className="flex items-center gap-2">
        <Button variant="outline" size="sm" className="h-9 gap-1" disabled={page <= 1}
          onClick={() => onChange(page - 1)} data-testid={`${testPrefix}-prev`}>
          <ChevronLeft className="h-4 w-4" /> Précédent
        </Button>
        <Button variant="outline" size="sm" className="h-9 gap-1" disabled={page >= pages}
          onClick={() => onChange(page + 1)} data-testid={`${testPrefix}-next`}>
          Suivant <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
